import { Options, Vue } from 'vue-class-component';
import { getMenuTree } from "@/api/index";
import { NavsDto } from '@/model/web/NavsDto';

@Options({})
export default class Nav extends Vue {
    public navs: NavsDto[] = []; 


    // 获取导航菜单
    public getMenuList() {
        getMenuTree('MENU_CLASSFIER_WEBSITE').then((res: any) => {
            for (const item of res.data) {
                item.path === this.$route.path ? item.checked = true : item.checked = false;
            }
            this.navs = res.data;
        });
    }
    public navClick(i: number) {
        for(const item of this.navs) {
            item.checked = false;
            this.navs[i].checked = true;
        }
        this.$router.push(this.navs[i].path);
    }
    public mounted() {
        this.getMenuList();
    }

}
